import type { DrawLevel, ModLevels } from '@ps/web-shared-api-types/v1-preview/SwPkrSpinAndGo';
import React, { useContext } from 'react';

import { PrizePlayerProviderContext } from '../../../../providers/PrizePlayerProvider';

import CashOutRow from './CashOutRow/CashOutRow';
import styles from './HoldemMaxPrizeTable.scss';
import PrizeRows from './PrizeRows/PrizeRows';
import ProbabilityRow from './ProbabilityRow/ProbabilityRow';

interface HoldemMaxPrizeTableProps {
  data: ModLevels[] | undefined;
  drawLevels: DrawLevel[];
  placeAwardsMaxLength: number;
  currency: number;
  scalePM: number;
}

const HoldemMaxPrizeTable: React.FC<HoldemMaxPrizeTableProps> = ({ data, currency, scalePM }) => {
  const { selectedPlayerIndex } = useContext(PrizePlayerProviderContext);
  const transposedData = data?.[selectedPlayerIndex]?.drawLevels?.slice().reverse() ?? [];

  return (
    <table className={styles.prizeTable}>
      <tbody>
        <ProbabilityRow transposedData={transposedData} currency={currency} />
        <PrizeRows
          transposedData={transposedData}
          modLevels={data}
          scalePM={scalePM}
          currency={currency}
          selectedPlayerIndex={selectedPlayerIndex}
        />
        <CashOutRow transposedData={transposedData} />
      </tbody>
    </table>
  );
};

export default HoldemMaxPrizeTable;
